import React, { useEffect } from "react";
import { useMsal, useAccount } from "@azure/msal-react";
import axios from "axios";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginRequest } from "./authConfig";



  const RequestInterceptor = ({children}) => {

    const {instance, accounts} = useMsal();
    const account = useAccount(accounts[0]);

    useEffect(() => {
      const interceptorId = axios.interceptors.request.use(async (config) => {
        const activeAccount = account || accounts[0];
        if (!activeAccount) {
          throw Error("No active account!");
        }

        try {
          const response = await instance.acquireTokenSilent({
            ...loginRequest,
            account: activeAccount,
          });

          const bearer = `Bearer ${response.accessToken}`;
          config.headers["Authorization"] = bearer;
          return config;
        } catch (error) {
          const errorText = `${error?.errorCode || ""} ${error?.message || ""}`.toLowerCase();
          const shouldReauthenticate =
            error instanceof InteractionRequiredAuthError ||
            errorText.includes("aadsts700084") ||
            errorText.includes("invalid_grant") ||
            errorText.includes("interaction_required");

          if (shouldReauthenticate) {
            await instance.acquireTokenRedirect({
              ...loginRequest,
              account: activeAccount,
            });
          }

          return Promise.reject(error);
        }
      });

      return () => {
        axios.interceptors.request.eject(interceptorId);
      };
    }, [instance, account, accounts]);

    return (
        <>
          {children}
        </>
      ); 
};
export default RequestInterceptor;